<template>
  <div class="label-print" v-loading="loading">
    <!-- 型号选择 + 打印按钮 -->
    <div class="toolbar">
      <el-select v-model="selectedModel" placeholder="请选择型号" @change="onModelChange" style="width:200px;">
        <el-option v-for="(m, i) in modelList" :key="i" :label="m" :value="m" />
      </el-select>
      <div class="toolbar-center">
        <el-button type="warning" @click="dialogVisible = true">设置</el-button>
        <div class="batch-info">
          <span class="batch-label">开始批次：</span>
          <span class="batch-value">{{ currentBatchText }}</span>
          <span class="batch-divider">|</span>
          <span class="batch-label">张数：</span>
          <span class="batch-value">{{ printCount }}</span>
        </div>
        <el-button type="primary" :class="{ 'btn-disabled': !startBatch }" @click="handlePrintClick">打印</el-button>
      </div>
    </div>

    <!-- 设置起始批次弹窗 -->
    <el-dialog title="设置" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="起始批次号">
          <el-input v-model="batchInput" placeholder="请输入起始批次号" />
        </el-form-item>
        <el-form-item label="打印张数">
          <el-input v-model.number="printCount" type="number" :min="1" :max="9999" placeholder="请输入要打印的张数" style="width:100%;" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" round @click="confirmBatch">确定</el-button>
      </span>
    </el-dialog>

    <template v-if="modelData">
      <!-- 标签容器 -->
      <div class="label-wrapper" ref="labelWrapper">
        <!-- 第一联 -->
        <div class="label-item">
          <div class="label-box label-copy1">
            <table class="label-table">
              <tr class="head-row">
                <td>Модель: {{ modelData.model }}</td>
                <td class="wrap-cell">Тип продукта: электрический одноконтурный котёл</td>
              </tr>
              <tr class="body-row">
                <td>Диапазон температур: {{ modelData.temperatureRange }}</td>
                <td>Размер короба: {{ modelData.boxSpecifications }}</td>
              </tr>
              <tr class="body-row">
                <td>Электропитание: {{ modelData.ratedVoltage }}</td>
                <td>Вес HETTO: {{ modelData.netWeight }}</td>
              </tr>
              <tr class="body-row">
                <td>Мощность: {{ modelData.power }}</td>
                <td>Вес БРУТТО: {{ modelData.grossWeight }}</td>
              </tr>
              <tr class="body-row">
                <td>Дата производства:</td>
                <td>Серийный номер:</td>
              </tr>
              <tr class="body-row">
                <td>{{ labelBatch.substring(0, 8) }}</td>
                <td><svg ref="barcode1"></svg></td>
              </tr>
              <tr class="body-row">
                <td></td>
                <td>{{ labelBatch }}</td>
              </tr>
            </table>
          </div>
          <div class="label-title">第一联</div>
        </div>

        <!-- 第二联 -->
        <div class="label-item">
          <div class="label-box label-copy2">
            <table class="label-table">
              <tr class="head-row">
                <td>Модель: {{ modelData.model }}</td>
                <td class="wrap-cell">Тип продукта: электрический одноконтурный котёл</td>
              </tr>
              <tr class="body-row">
                <td>Диапазон температур: {{ modelData.temperatureRange }}</td>
                <td>Размер короба: {{ modelData.boxSpecifications }}</td>
              </tr>
              <tr class="body-row">
                <td>Электропитание: {{ modelData.ratedVoltage }}</td>
                <td>Вес HETTO: {{ modelData.netWeight }}</td>
              </tr>
              <tr class="body-row">
                <td>Мощность: {{ modelData.power }}</td>
                <td>Вес БРУТТО: {{ modelData.grossWeight }}</td>
              </tr>
              <tr class="body-row">
                <td>Дата производства:</td>
                <td>Серийный номер:</td>
              </tr>
              <tr class="body-row">
                <td>{{ labelBatch.substring(0, 8) }}</td>
                <td><svg ref="barcode2"></svg></td>
              </tr>
              <tr class="body-row">
                <td></td>
                <td>{{ labelBatch }}</td>
              </tr>
            </table>
          </div>
          <div class="label-title">第二联</div>
        </div>

        <!-- 第三联 -->
        <div class="label-item">
          <div class="label-box label-copy3">
            <div class="copy3-content">
              <img ref="qrImg" class="qr-code" />
              <span class="batch-no">{{ labelBatch }}</span>
            </div>
          </div>
          <div class="label-title">第三联</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode'
import QRCode from 'qrcode'

export default {
  name: 'foreignTrade_produce',
  data() {
    return {
      loading: false,
      allModelData: [],
      modelList: [],
      selectedModel: '',
      modelData: null,
      startBatch: null,
      currentBatch: null,
      nextBatch: null,
      dialogVisible: false,
      printCount: 1,
      batchInput: '',
      produceDate: '20260630'
    }
  },
  computed: {
    currentBatchText() {
      return this.startBatch || ''
    },
    labelBatch() {
      if (this.nextBatch) return this.nextBatch
      const now = new Date()
      return `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}XXXX`
    }
  },
  mounted() {
    this.fetchModelList()
  },
  watch: {
    modelData(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.renderBarcodes()
            this.renderQR()
          }, 100)
        })
      }
    }
  },
  methods: {
    async fetchModelList() {
      this.loading = true
      try {
        const res = await this.$api.getAllModelInfo()
        if (res.code === 200 && res.data) {
          this.allModelData = res.data
          this.modelList = res.data.map(item => item.model)
          if (this.modelList.length > 0) {
            this.selectedModel = this.modelList[0]
            this.setModelData(this.selectedModel)
            this.$nextTick(() => { this.loadCache(this.selectedModel) })
          }
        }
      } finally {
        this.loading = false
      }
    },
    onModelChange(val) {
      this.setModelData(val)
      this.loadCache(val)
    },
    setModelData(val) {
      const found = this.allModelData.find(item => item.model === val)
      if (found) {
        this.modelData = { ...found }
      }
    },
    saveCache() {
      try {
        const all = JSON.parse(localStorage.getItem('foreignTrade_settings') || '{}')
        all[this.selectedModel] = {
          startBatch: this.startBatch,
          printCount: this.printCount,
          timestamp: Date.now()
        }
        localStorage.setItem('foreignTrade_settings', JSON.stringify(all))
      } catch (e) {}
    },
    loadCache(model) {
      const m = model || this.selectedModel
      try {
        const all = JSON.parse(localStorage.getItem('foreignTrade_settings') || '{}')
        const cache = all[m]
        if (!cache || Date.now() - cache.timestamp > 86400000) {
          this.resetBatch()
          return
        }
        if (cache.startBatch) {
          this.startBatch = cache.startBatch
          this.batchInput = cache.startBatch
          this.currentBatch = cache.startBatch
          this.nextBatch = cache.startBatch
          if (cache.printCount) this.printCount = cache.printCount
          this.$nextTick(() => { this.renderBarcodes() })
        }
      } catch (e) { this.resetBatch() }
    },
    resetBatch() {
      this.startBatch = null
      this.currentBatch = null
      this.nextBatch = null
      this.batchInput = ''
      this.printCount = 1
    },
    async confirmBatch() {
      const val = this.batchInput.trim()
      if (!val) {
        this.$message.warning('请设置正确的起始值')
        return
      }
      const res = await this.$api.checkFirstSerialNumber({
        model: this.modelData.model,
        firstSerialNumber: val
      })
      if (res.code !== 200) {
        this.$message.error('初始序列已被使用')
        return
      }
      this.startBatch = val
      this.currentBatch = val
      this.nextBatch = val
      this.saveCache()
      this.dialogVisible = false
      this.$nextTick(() => {
        this.renderBarcodes()
      })
    },
    renderBarcodes() {
      if (!this.$refs.barcode1 || !this.$refs.barcode2) return
      JsBarcode(this.$refs.barcode1, this.labelBatch, {
        format: 'CODE128', width: 1, height: 24, displayValue: false, margin: 2
      })
      JsBarcode(this.$refs.barcode2, this.labelBatch, {
        format: 'CODE128', width: 1, height: 24, displayValue: false, margin: 2
      })
    },
    generateQRDataUrl(batchNo) {
      return new Promise((resolve) => {
        QRCode.toDataURL(this.getQrUrl(batchNo), { width: 256 }, (err, url) => {
          resolve(err ? '' : url)
        })
      })
    },
    getQrUrl(batchNo) {
      const model = this.modelData ? this.modelData.model : ''
      const sn = batchNo || this.labelBatch
      return `https://www.chiffoele.com/GasSafetySystem/foreigntrade/getProductionInfoByQrcode?model=${model}&serialNumber=${sn}`
    },
    renderQR(batchNo) {
      const url = this.getQrUrl(batchNo)
      QRCode.toDataURL(url, { width: 256 }, (err, dataUrl) => {
        if (!err && this.$refs.qrImg) {
          this.$refs.qrImg.src = dataUrl
        }
      })
    },
    svgToPngUrl(svgEl, w, h) {
      return new Promise((resolve) => {
        const canvas = document.createElement('canvas')
        canvas.width = w
        canvas.height = h
        const ctx = canvas.getContext('2d')
        const img = new Image()
        const clone = svgEl.cloneNode(true)
        const serializer = new XMLSerializer()
        const svgStr = serializer.serializeToString(clone)
        img.onload = () => {
          ctx.drawImage(img, 0, 0, w, h)
          resolve(canvas.toDataURL('image/png'))
        }
        img.onerror = () => resolve('')
        img.src = 'data:image/svg+xml,' + encodeURIComponent(svgStr)
      })
    },
    getLodop() {
      var LODOP
      try { LODOP = new ActiveXObject('CLodop.1'); return LODOP } catch (e) {}
      try { LODOP = new ActiveXObject('Lodop.1'); return LODOP } catch (e) {}
      try { LODOP = new ActiveXObject('LODOP.Print'); return LODOP } catch (e) {}
      if (typeof window.getCLodop !== 'undefined') {
        LODOP = window.getCLodop()
        if (LODOP) return LODOP
      }
      LODOP = document.getElementById('LODOP_OB')
      if (LODOP && typeof LODOP.SET_PRINT_PAGESIZE === 'function') return LODOP
      var embed = document.createElement('embed')
      embed.id = 'LODOP_OB'
      embed.type = 'application/x-print-lodop'
      embed.width = 0
      embed.height = 0
      embed.style.cssText = 'position:absolute;left:-100px;top:-100px;'
      document.body.appendChild(embed)
      return embed && typeof embed.SET_PRINT_PAGESIZE === 'function' ? embed : null
    },
    barcodeToDataUrl(batchNo) {
      return new Promise((resolve) => {
        const canvas = document.createElement('canvas')
        canvas.width = 320
        canvas.height = 30
        JsBarcode(canvas, batchNo, {
          format: 'CODE128', width: 1, height: 24, displayValue: false, margin: 2
        })
        resolve(canvas.toDataURL('image/png'))
      })
    },
    printLabel(LODOP, top, left, width, height, batchNo, barcodeUrl) {
      const d = this.modelData
      const colW = '50%'
      const dateStr = (batchNo || '').substring(0, 8)
      const html = `<table style="font-size:14px;font-weight:600;color:#000;font-family:Arial,sans-serif;border-collapse:collapse;line-height:1.1;padding:0;margin:0;">` +
        `<tr style="font-weight:bold;height:16px;"><td style="width:${colW};text-align:center;border:1px solid #333;padding:0 1px;">Модель: ${d.model}</td><td style="width:${colW};text-align:center;border:1px solid #333;padding:0 1px;">Тип продукта: электрический одноконтурный котёл</td></tr>` +
        `<tr><td style="text-align:center;border-left:1px solid #333;border-right:1px solid #333;padding:0 1px;">Диапазон температур: ${d.temperatureRange}</td><td style="text-align:center;border-left:1px solid #333;border-right:1px solid #333;padding:0 1px;">Размер короба: ${d.boxSpecifications}</td></tr>` +
        `<tr><td style="text-align:center;border-left:1px solid #333;border-right:1px solid #333;padding:0 1px;">Электропитание: ${d.ratedVoltage}</td><td style="text-align:center;border-left:1px solid #333;border-right:1px solid #333;padding:0 1px;">Вес HETTO: ${d.netWeight}</td></tr>` +
        `<tr><td style="text-align:center;border-left:1px solid #333;border-right:1px solid #333;padding:0 1px;">Мощность: ${d.power}</td><td style="text-align:center;border-left:1px solid #333;border-right:1px solid #333;padding:0 1px;">Вес БРУТТО: ${d.grossWeight}</td></tr>` +
        `<tr><td style="text-align:center;border-left:1px solid #333;border-right:1px solid #333;padding:0 1px;">Дата производства:</td><td style="text-align:center;border-left:1px solid #333;border-right:1px solid #333;padding:0 1px;">Серийный номер:</td></tr>` +
        `<tr><td style="text-align:center;border-left:1px solid #333;border-right:1px solid #333;padding:0 1px;">${dateStr}</td><td style="text-align:center;border-left:1px solid #333;border-right:1px solid #333;padding:0 1px;"><img src="${barcodeUrl}"></td></tr>` +
        `<tr><td style="text-align:center;border-left:1px solid #333;border-right:1px solid #333;border-bottom:1px solid #333;padding:0 1px;"></td><td style="text-align:center;border-left:1px solid #333;border-right:1px solid #333;border-bottom:1px solid #333;padding:0 1px;">${batchNo}</td></tr>` +
        `</table>`
      LODOP.ADD_PRINT_HTM(top + 'mm', left + 'mm', width + 'mm', height + 'mm', html)
      LODOP.SET_PRINT_STYLEA(0, 'Stretch', 1)
    },
    handlePrintClick() {
      if (!this.startBatch) {
        this.$message.warning('请先完成设置')
        return
      }
      this.handlePrint()
    },
    async handlePrint() {
      if (!this.modelData) {
        this.$message.warning('请先选择型号')
        return
      }
      const LODOP = this.getLodop()
      if (!LODOP) {
        this.$message.warning('请先安装Lodop打印控件')
        return
      }

      const qrUrl = this.$refs.qrImg.src
      const startNum = parseInt(this.startBatch || this.labelBatch, 10)

      LODOP.SET_LICENSES('', '', '', '')
      LODOP.SET_PRINT_PAGESIZE(2, 290, 60, 'LBL290x60')
      LODOP.SET_PRINT_MODE('CUSTOM_PAGE_NAME', 'LBL290x60')
      LODOP.SET_PRINT_MODE('PAGE_MARGIN_TOP', '0mm')
      LODOP.SET_PRINT_MODE('PAGE_MARGIN_BOTTOM', '0mm')
      LODOP.PRINT_INITA('0mm', '0mm', '290mm', '60mm', '标签打印')
      LODOP.SET_SHOW_MODE('PREVIEW_IN_BROWSE', 1)
      LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 0, 0, '')

      for (let i = 0; i < this.printCount; i++) {
        const batchNo = String(startNum + i)
        const barcodeUrl = await this.barcodeToDataUrl(batchNo)
        const qrDataUrl = await this.generateQRDataUrl(batchNo)

        if (i > 0) LODOP.NewPage()

        this.printLabel(LODOP, 5, 10, 88, 54, batchNo, barcodeUrl)
        this.printLabel(LODOP, 5, 125, 88, 54, batchNo, barcodeUrl)
        const copy3Html = `<div style="text-align:center;padding-top:2mm;">
          <img src="${qrDataUrl}" style="width:24mm;height:24mm;">
          <span style="font-size:14px;font-weight:600;color:#000;font-family:Arial,sans-serif;display:block;margin-top:2.5mm;">${batchNo}</span>
        </div>`
        LODOP.ADD_PRINT_HTM('0mm', '231mm', '50mm', '60mm', copy3Html)
      }

      const self = this
      const totalCount = this.printCount
      const modelPrinted = this.modelData.model
      const firstSerial = self.startBatch
      LODOP.On_Return = function(TaskID, Value) {
        if (Value) {
          self.$confirm('是否已完成打印？', '确认', {
            confirmButtonText: '已完成',
            cancelButtonText: '未完成',
            type: 'info'
          }).then(() => {
            const lastBatch = String(startNum + totalCount)
            self.startBatch = lastBatch
            self.nextBatch = lastBatch
            self.currentBatch = lastBatch
            self.saveCache()
            const baseURL = self.$baseURL || 'https://www.chiffoele.com/GasSafetySystem'
            const qs = `model=${encodeURIComponent(modelPrinted)}&firstSerialNumber=${encodeURIComponent(firstSerial)}&quantity=${totalCount}`
            fetch(`${baseURL}/foreigntrade/produce?${qs}`, { credentials: 'include' })
              .then(r => r.json()).then(res => {
                console.log('生产记录上报成功', res)
              }).catch(err => {
                console.error('生产记录上报失败:', err)
              })
          }).catch(() => {
            console.log('用户取消确认，未更新批次')
          })
        } else {
          console.log('打印任务提交失败')
        }
      }
      LODOP.PREVIEW()
    }
  }
}
</script>

<style scoped>
.label-print {
  padding: 20px;
}

.toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.toolbar-center {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-left: 10%;
}

.batch-info {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 15px;
}

.batch-label {
  color: #666;
  font-weight: 500;
}

.batch-value {
  color: #1a1a1a;
  font-weight: 700;
  font-family: 'Courier New', Consolas, monospace;
  letter-spacing: 1px;
}

.dialog-footer .el-button + .el-button {
  margin-left: 16px;
}

.el-dialog .el-input__inner {
  text-align: left;
}

.btn-disabled {
  opacity: 0.5;
  pointer-events: auto;
  cursor: not-allowed;
}

.batch-divider {
  color: #ccc;
  margin: 0 8px;
}

.label-wrapper {
  display: flex;
  gap: 40px;
  justify-content: center;
  align-items: flex-start;
  margin-top: 50px;
}

.label-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.label-title {
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.label-box {
  position: relative;
  background: #fff;
}

.label-copy1,
.label-copy2 {
  width: 115mm;
  height: 60mm;
  padding: 4mm 5mm;
  box-sizing: border-box;
}

.label-copy3 {
  width: 60mm;
  height: 60mm;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 1mm;
  box-sizing: border-box;
}

.copy3-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-code {
  width: 28mm;
  height: 28mm;
}

.batch-no {
  font-size: 13px;
  font-weight: 600;
  color: #000;
  margin-top: 5mm;
}

/* 标签表格 */
.label-table {
  width: 100%;
  height: 100%;
  border-collapse: collapse;
  border: 1px solid #333;
  table-layout: fixed;
}

.label-table td {
  border: 1px solid #333;
  text-align: center;
  vertical-align: middle;
  font-size: 10px;
  width: 50%;
  padding: 0 1px;
  line-height: 1;
  font-weight: 600;
  color: #000;
}

.label-table .head-row td {
  font-weight: bold;
  font-family: Arial, sans-serif;
  line-height: 1;
}

.label-table .head-row {
  height: 14px;
}

.wrap-cell {
  word-break: break-word;
  white-space: normal;
  line-height: 1.3;
}

.label-table .body-row td {
  border-top: none;
  border-bottom: none;
}

.label-table svg {
  display: block;
  max-width: 100%;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}

.label-table td {
  overflow: hidden;
}
</style>
